import { Component, OnDestroy, OnInit } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { Subscription } from 'rxjs';
import { DynamicFormService } from '../../dynamic-form/dynamic-form.service';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { FormlyModule } from '@ngx-formly/core';
import { TranslateModule } from '@ngx-translate/core';
import { ICONS } from '../../../../_helpers/icons.constants';

@Component({
    selector: 'formly-advance-policy',
    templateUrl: "./formly-advance-policy.component.html",
    standalone: true,
    imports: [CommonModule, TranslateModule, ReactiveFormsModule, FormlyModule]
})
export class AdvancePolicyComponent extends FieldType implements OnInit, OnDestroy {
  isFormSubmitted: boolean = false;
  formSubmissionSubscription: Subscription;
  public ICONS = ICONS;
  advanceCappingLimit = false;

  constructor(private dynamicFormService: DynamicFormService) {
    super();
  }

  ngOnInit() {

    if(this.model.advanceLimit) {
      this.advanceCappingLimit =true;
    }

    this.formSubmissionSubscription = this.dynamicFormService.getFormSubmittedEvent().subscribe(data => {
      this.isFormSubmitted = data;
    });
  }

  ngOnDestroy() {
    if (this.formSubmissionSubscription) {
      this.formSubmissionSubscription.unsubscribe();
    }
  }

}
